import { VectorGraphics } from "./VectorGraphics.js"

/**
 * Static class with video related utilities
 * @memberof vef.ui.media
 * @author ckraemme <ckraemme@awi.de>
 */
export class VideoPlayerUtils {
    /**
     * Get the data url of the video player poster based on the hostname
     */
    static getPoster() {
        const hostname = window.location.hostname;
        const whiteColor = '#f2f2f2';
        const backgroundColor = '#0000';
        let posterUrl = undefined;
        if (hostname.includes('marine-data'))
            posterUrl = VectorGraphics.marineDataLogo(whiteColor, whiteColor, backgroundColor);
        else if (hostname.includes('earth-data'))
            posterUrl = VectorGraphics.earthDataLogo(whiteColor, whiteColor, backgroundColor);
        else if (hostname.includes('o2a-data'))
            posterUrl = VectorGraphics.o2aDataLogo(whiteColor, whiteColor, backgroundColor, backgroundColor);
        else
            posterUrl = VectorGraphics.o2aDataLogo(whiteColor, whiteColor, backgroundColor, backgroundColor);
        return posterUrl
    }
}